/**
 * Accepted ZIP code / postal code regexps
 */

export const postCodeRegexp = /^\d{4}$/;
export const postalCodeInputRegexp =
  '[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]?\\d[ABCEGHJ-NPRSTV-Z]\\d';
export const postalCodeRegexp =
  /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/;
export const zipCodeInputRegexp = '\\d*';
export const zipCodeRegexp = /^\d{5}$/;
